module.exports = __webpack_public_path__ + "static/media/talentx_logo_black@3x.5e324053.png";